import {getCookie} from '@miro-site/utils-storage'
import {checkUserInfo} from '@mirohq-internal/website-utils'

type TSSEvents = {
  view: (templateId: string) => void
  copy: (templateId: string) => void
}

type TSSPayload = {
  userId: number
  sessionId: string
  anonymousId: string
}

const MAX_RETRIES_COUNT = 3
export const TSS_BASE = process.env.NEXT_PUBLIC_TSS_ENDPOINT
export const SESSION_ID_KEY = 'SESSION_ID_KEY'
export const ANONYMOUS_ID_KEY = 'ajs_anonymous_id'

export const getTSSPayload = async (retry = 1): Promise<TSSPayload | null> => {
  const sessionId = window.sessionStorage.getItem(SESSION_ID_KEY)

  // Wait for the session id to be set
  if (!sessionId) {
    await new Promise(resolve => {
      setTimeout(resolve, 1000 * retry)
    })

    if (retry === MAX_RETRIES_COUNT) {
      throw new Error('Could not get the session id')
    }

    return await getTSSPayload(retry + 1)
  }

  const {id: userId} = checkUserInfo() || {id: undefined}

  const anonymousId = (!userId && getCookie(ANONYMOUS_ID_KEY)?.replace(/"/g, '')) || undefined

  if (!userId && !anonymousId) {
    return null
  }

  return {
    userId,
    sessionId,
    anonymousId,
  }
}

const sendTSSBeacon = async (templateId: string, action: string) => {
  const payload = await getTSSPayload()

  if (!payload) {
    return
  }

  const blob = new Blob([JSON.stringify(payload)], {
    type: 'application/json',
  })

  navigator?.sendBeacon?.(`${TSS_BASE}templates/${templateId}/${action}`, blob)
}

export const TSS: TSSEvents = {
  view: (templateId: string) => {
    sendTSSBeacon(templateId, 'views')
  },

  copy: (templateId: string) => {
    sendTSSBeacon(templateId, 'copies')
  },
}
